<template>
	<div>
		<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
		<b-alert variant="danger" :show="!!error" class="mb-0">{{error}}</b-alert>
		<b-alert variant="success" :show="!!message" class="mb-0">{{message}}</b-alert>
	</div>
</template>
<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		message: null,
	}},
	created() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		if(!params.code) {
			this.error = 'No code specified';
			return;
		}

		this.loading++;
		this.$api.post('confirmUserEmailCode', { code: params.code }).then(() => {
			this.message = 'Successfully confirmed! You will shortly be redirected to login.';
			setTimeout(() => window.location = `${this.$baseUrl}/app`, 3000);
		}, err => this.error = err).finally(() => this.loading--);
	},
}
</script>
